module.exports = __webpack_public_path__ + "img/150-3.48a03911.jpg";